import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Edit.svg?component
var Edit_exports = /* @__PURE__ */ __exportAll({
	default: () => Edit_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M14 3H5.571A2.57 2.57 0 0 0 3 5.571V18.43A2.57 2.57 0 0 0 5.571 21H18.43A2.57 2.57 0 0 0 21 18.429V10m.96-5.35a1.845 1.845 0 0 0-2.61-2.61l-6.644 6.647a1.3 1.3 0 0 0-.328.543l-.864 2.849a.327.327 0 0 0 .408.407l2.849-.864c.205-.062.391-.174.543-.325l6.645-6.647Z"
	}, null, -1)])]);
}
var Edit_default = { render: render$1 };
//#endregion
export { Edit_exports, Edit_default as default, render$1 as render };

//# sourceMappingURL=Edit.svg.virtual.js.map